import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type WarningFillProps = IconComponentBaseProps;

export const WarningFill = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: WarningFillProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_7277_12903" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7277_12903)">
        <path
          d="M3.42549 20.5C3.25599 20.5 3.10374 20.4586 2.96874 20.3757C2.83374 20.2929 2.72882 20.1837 2.65399 20.048C2.57599 19.9133 2.53307 19.7675 2.52524 19.6105C2.51741 19.4535 2.55974 19.298 2.65224 19.144L11.213 4.35599C11.3057 4.20199 11.4215 4.08816 11.5605 4.01449C11.6997 3.94083 11.8462 3.90399 12 3.90399C12.1538 3.90399 12.3003 3.94083 12.4395 4.01449C12.5785 4.08816 12.6943 4.20199 12.787 4.35599L21.3477 19.144C21.4402 19.298 21.4826 19.4535 21.4747 19.6105C21.4669 19.7675 21.424 19.9133 21.346 20.048C21.2712 20.1837 21.1662 20.2929 21.0312 20.3757C20.8962 20.4586 20.744 20.5 20.5745 20.5H3.42549ZM12 17.8077C12.2288 17.8077 12.4207 17.7303 12.5755 17.5755C12.7303 17.4207 12.8077 17.2288 12.8077 17C12.8077 16.7712 12.7303 16.5793 12.5755 16.4245C12.4207 16.2697 12.2288 16.1922 12 16.1922C11.7712 16.1922 11.5793 16.2697 11.4245 16.4245C11.2697 16.5793 11.1922 16.7712 11.1922 17C11.1922 17.2288 11.2697 17.4207 11.4245 17.5755C11.5793 17.7303 11.7712 17.8077 12 17.8077ZM12.0002 15.1922C12.2129 15.1922 12.391 15.1204 12.5345 14.9767C12.6782 14.8329 12.75 14.6547 12.75 14.4422V10.9422C12.75 10.7297 12.6781 10.5517 12.5342 10.408C12.3904 10.2642 12.2122 10.1922 11.9997 10.1922C11.7871 10.1922 11.609 10.2642 11.4655 10.408C11.3218 10.5517 11.25 10.7297 11.25 10.9422V14.4422C11.25 14.6547 11.3219 14.8329 11.4657 14.9767C11.6096 15.1204 11.7877 15.1922 12.0002 15.1922Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
